"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOUpdatePackagePrice = exports.IOPackages = exports.initializePackages = exports.updatePackagePrice = exports.setPackagesError = exports.updatePackagesAction = exports.setPackagesAction = void 0;
/* eslint-disable functional/prefer-readonly-type */
const monda_1 = require("@simplisafe/monda");
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const when_1 = __importDefault(require("ramda/src/when"));
const query_1 = require("../commercetools/query");
const utils_1 = require("../products/utils");
const utils_2 = require("../redux/utils");
const errorLogging_1 = require("../thirdparty/errorLogging");
const commercetools_1 = require("./commercetools");
const setPackagesAction = (packages) => ({
    '@@type': 'package',
    payload: packages,
    type: 'SET_PACKAGES'
});
exports.setPackagesAction = setPackagesAction;
const updatePackagesAction = (packages) => ({
    '@@type': 'package',
    payload: packages,
    type: 'UPDATE_PACKAGES'
});
exports.updatePackagesAction = updatePackagesAction;
const setPackagesError = (error) => ({
    '@@type': 'package',
    payload: monet_1.Maybe.fromUndefined(error),
    type: 'SET_PACKAGES_ERROR'
});
exports.setPackagesError = setPackagesError;
const updatePackagePrice = (_package) => ({
    '@@type': 'package',
    payload: _package,
    type: 'UPDATE_PACKAGE_PRICE'
});
exports.updatePackagePrice = updatePackagePrice;
/**
 * Sets packages from a local payload.
 * Packages should already be parsed using formatPackageResponse.
 * This is for adding packages to the front-end that are fetched during the build.
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   dispatch(initializePackages(packages))
 * }, [ dispatch, packages ])
 */
const initializePackages = 
// eslint-disable-next-line sonarjs/no-identical-functions
(packages) => ({
    '@@type': 'package',
    payload: packages,
    type: 'SET_PACKAGES'
});
exports.initializePackages = initializePackages;
/**
 * Fetches packages from external source and populates Redux with results.
 * TODO: make this a redux-thunk action so it can be used as `dispatch(IOPackages())`
 * TODO: use locale from redux store instead of taking as argument
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   IOPackages(dispatch)('en-US').run()
 * }, [ dispatch ])
 */
const IOPackages = (locale) => (dispatch) => (0, commercetools_1.commercetoolsRequestPackages)(locale)
    .pipe((0, fluture_1.map)(commercetools_1.formatPackageResponse))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    dispatch((0, exports.setPackagesError)(e));
})((packages) => packages.cata(e => {
    (0, errorLogging_1.logError)(e);
    dispatch((0, exports.setPackagesError)(e));
}, packages => dispatch((0, exports.updatePackagesAction)(packages)))));
exports.IOPackages = IOPackages;
/**
 * Request a single product by key and returns the latest price info
 *
 * @public
 */
const IOUpdatePackagePrice = (productKey) => (dispatch, getState) => {
    const state = getState();
    const lastFetched = (0, monda_1.safeProp)('products', state)
        .chain(products => (0, monda_1.safeProp)('value', products))
        .chain(value => monet_1.Maybe.fromUndefined(value.get(productKey)))
        .chain(product => (0, monda_1.safeProp)('lastFetched', product))
        .getOrElse(0);
    const updatePrice = () => (0, query_1.commercetoolsRequestProductByKey)(productKey)
        .pipe((0, fluture_1.map)((0, query_1.parseProductQueryResponse)(productKey)))
        .pipe((0, fluture_1.map)((val) => val.map(utils_1.pickPriceDetails)))
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        dispatch((0, exports.setPackagesError)(e));
    })(product => {
        product.cata(e => {
            (0, errorLogging_1.logError)(e);
            dispatch((0, exports.setPackagesError)(e));
        }, 
        // TODO this has to be moved and the types fixed
        // @ts-ignore
        p => dispatch((0, exports.updatePackagePrice)(p)));
    }));
    (0, when_1.default)(utils_2.shouldRefetch, updatePrice)(lastFetched);
};
exports.IOUpdatePackagePrice = IOUpdatePackagePrice;
//# sourceMappingURL=actions.js.map